import React, { FC } from "react";

import { ImportFile } from "./ImportFile";
import { ImportObjects } from "./ImportObjects";
import { ImportAttributes } from "./ImportAttributes";
import { ImportMeta } from "./ImportMeta";
import { ImportFinish } from "./ImportFinish";
import { useImportContext } from "../importContext";
import { KMLImportStep } from "../types";

export const KMLImportSteps: FC = () => {
  const { step } = useImportContext();

  switch (step) {
    case KMLImportStep.Finish:
      return <ImportFinish />;
    case KMLImportStep.Meta:
      return <ImportMeta />;
    case KMLImportStep.Attributes:
      return <ImportAttributes />;
    case KMLImportStep.Objects:
      return <ImportObjects />;
    default:
      return <ImportFile />;
  }
};
